import { useEffect, useState } from "react";
import { isLocalhost } from "../utils/constants";

export const useEnvironment = () => {
  const [environment, setEnvironment] = useState<"mobile" | "web">("web");

  useEffect(() => {
    if (
      isLocalhost ||
      window.location.hostname.startsWith("mobile.") ||
      window.location.hostname.startsWith("mobile-")
    ) {
      setEnvironment("mobile");
    } else {
      setEnvironment("web");
    }
  }, []);

  return { environment };
};
